// angular
import { Routes } from '@angular/router';
import { RoleGuard } from '@app/guards/role.guard';
// components
import { SuppliersListComponent } from '@suppliers/suppliers-list/suppliers-list.component';
import { InstallersComponent } from '@installers/installers.component';
import { DevelopersComponent } from '@developers/developers.component';
import { ArchitectsComponent } from '@architects/architects.component';
// enums
import { Roles } from '@app/shared/enums/roles.enum';

export const SuppliersRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@app/+solutions/solutions-page/solutions-page.component').then(
        m => m.SolutionsPageComponent
      ),
    data: { titleKey: 'routes.solutions' },
  },
  {
    path: 'suppliers',
    component: SuppliersListComponent,
    data: { titleKey: 'routes.suppliers' },
  },
  {
    path: 'suppliers/:id',
    loadComponent: () =>
      import('@app/+solutions/person-detail/person-detail.component').then(
        m => m.PersonDetailComponent
      ),
    data: { titleKey: 'routes.portfolio' },
  },
  {
    path: 'installers',
    component: InstallersComponent,
    data: { titleKey: 'global.installers' },
  },
  {
    path: 'installers/:id',
    loadComponent: () =>
      import('@app/+solutions/person-detail/person-detail.component').then(
        m => m.PersonDetailComponent
      ),
    data: { titleKey: 'routes.portfolio' },
  },
  {
    path: 'developers',
    component: DevelopersComponent,
    data: { titleKey: 'header.forDevelopersOwners' },
  },
  {
    path: 'developers/:id',
    loadComponent: () =>
      import('@app/+solutions/person-detail/person-detail.component').then(
        m => m.PersonDetailComponent
      ),
    data: { titleKey: 'routes.portfolio' },
  },
  {
    path: 'architects',
    component: ArchitectsComponent,
    data: { titleKey: 'header.forArchitectsDesigners' },
  },
  {
    path: 'architects/:id',
    loadComponent: () =>
      import('@app/+solutions/person-detail/person-detail.component').then(
        m => m.PersonDetailComponent
      ),
    data: { titleKey: 'routes.portfolio' },
  },
  {
    path: 'customers',
    component: SuppliersListComponent,
    data: { titleKey: 'routes.customers', roles: [Roles.ViewCustomers] },
    canActivate: [RoleGuard],
  },
];
